import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2518 12.0575H2.43701V1.68713H9.17775L11.2518 3.76121V12.0575ZM10.2148 11.0205H3.47405V2.72417H8.65923V4.27973H10.2148V11.0205Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.17782 6.35387H4.51115V5.31683H9.17782V6.35387Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.14078 8.42781H4.51115V7.39078H8.14078V8.42781Z",
			fill: "currentColor"
		})
	]
});
export default SvgDocuments;
